import React from 'react';
import Tooltip from './Tooltip';

const TruncatedText = ({ text = '', limit = 50, action = null }) => {
  const isTruncated = text.length > limit;
  const displayText = isTruncated ? text.slice(0, limit) + '....' : text;

  const content = (
    <span className="break-words">{displayText}</span>
  );

  return (
    <div className="flex items-center justify-center gap-2 max-w-full">
      {isTruncated ? <Tooltip text={text}>{content}</Tooltip> : content}
      {action && <span className="cursor-pointer">{action}</span>}
    </div>
  );
};

export default TruncatedText;
